module.exports = __webpack_public_path__ + "img/skirt.8051115a.svg";